import { EmailContent } from "../../../features/widgets/widget-content/widget-content.model";

export enum EmailTemplateType {
  BIRTHDAY_GREETING = 'Birthday Greeting',
  WEDDING_ANNIVERSARY = 'Wedding Anniversary',
  CHILDREN_BIRTHDAY = "Child's Birthday",
  UPCOMING_REVIEW_REMINDER = 'Upcoming Review Reminder',
}

export const EMAIL_TEMPLATES = new Map<EmailTemplateType, EmailContent>([
  [
    EmailTemplateType.BIRTHDAY_GREETING,
    {
      subject: 'Happy Birthday!',
      body: 'Dear <<name>>,\n\nWishing you a very happy birthday! We hope you have a fantastic day filled with joy and celebration.\n\nBest wishes,\nThe Team',
    },
  ],
  [
    EmailTemplateType.UPCOMING_REVIEW_REMINDER,
    {
      subject: 'Upcoming Review Reminder',
      body: 'Dear <<name>>,\n\nThis is a friendly reminder that you have an upcoming review scheduled. Please make sure to prepare any necessary documents or information.\n\nBest regards,\nThe Team',
    },
  ],
  [
    EmailTemplateType.WEDDING_ANNIVERSARY,
    {
      subject: 'Happy Wedding Anniversary!',
      body: 'Dear <<name>>,\n\nWishing you a very happy wedding anniversary! May your day be filled with love and joy.\n\nBest wishes,\nThe Team',
    },
  ],
  [
    EmailTemplateType.CHILDREN_BIRTHDAY,
    {
      subject: 'Happy Birthday to Your Child!',
      body: 'Dear <<name>>,\n\nWishing your child a very happy birthday! May their day be filled with fun and laughter.\n\nBest wishes,\nThe Team',
    },
  ],
]);
